import { SIGN_OUT_REASON_TIMEOUT } from '@/hooks/use-session-sign-out';

export const SESSION_TIMEOUT_MESSAGE =
  'Your session ended after a period of inactivity. Please sign in again.';

/**
 * Reads why the previous session ended from the router state left by the sign-out. Anything unexpected
 * yields no notice: router state is untyped and reachable through history, and the message carries no
 * PHI or PII either way (US-003 AC-001).
 */
export function readSessionNotice(state: unknown): string | null {
  if (typeof state !== 'object' || state === null || !('reason' in state)) {
    return null;
  }

  return state.reason === SIGN_OUT_REASON_TIMEOUT ? SESSION_TIMEOUT_MESSAGE : null;
}
